<script lang="ts">
	import type { PublicArticle } from "@core/schema/PublicArticle.js";
	import type { PublicCaseStudy } from "@core/schema/PublicCaseStudy.js";
	import { getNewsDetailPath } from "@core/schema/paths/getNewsDetailPath.js";
	import { findImageInContentBlocks } from "@core/schema/utils/findImageInContentBlocks.js";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import StructuredData from "./common/StructuredData.svelte";

	const { WEB_URL, FILE_BUCKET_URL_MAP } = getGlobalSettings();
	const { article }: { article: PublicArticle | PublicCaseStudy } = $props();

	const image = $derived(article.primaryImage ?? article.images[0] ?? findImageInContentBlocks(article.content));
	const url = $derived(`${WEB_URL}${getNewsDetailPath(article)}`);
</script>

<StructuredData
	data={{
		"@type": "Article",
		headline: article.title,
		description: article.perex,
		image: image && `${FILE_BUCKET_URL_MAP[image.bucket]}/${image.path}`,
		datePublished: article.publishedAt,
		dateModified: article.modifiedAt,
		author: {
			"@type": "Organization",
			name: "Commarec",
		},
		publisher: {
			"@type": "Organization",
			name: "Commarec",
			logo: {
				"@type": "ImageObject",
				url: `${WEB_URL}/logo.png`,
			},
		},
		mainEntityOfPage: url,
		url,
	}}
/>
